import {
  DashboardOutline,
  FormOutline,
  MenuFoldOutline,
  MenuUnfoldOutline,
  MenuOutline,
  HistoryOutline,
  LogoutOutline,
  FileTwoTone,
  DownloadOutline,
  InboxOutline,
  FileTextOutline,
  EyeInvisibleOutline,
  EyeOutline,
  PlusOutline,
  FilePdfFill,
  FilePdfOutline,
  FileAddOutline,
  UserOutline,
  SettingFill,
  PlusSquareFill,
  PlusSquareOutline,
  PlusCircleOutline,
  FileImageOutline,
  FileUnknownOutline,
  ArrowUpOutline,
  ArrowDownOutline,
  MessageOutline,
  ArrowLeftOutline,
  MailOutline,
  WarningOutline,
  UpOutline,
  DownOutline,
  ZoomInOutline,
  ZoomOutOutline,
  ArrowRightOutline,
  CreditCardOutline,
  GiftOutline,
  CheckOutline,
  LoadingOutline,
  InfoCircleOutline,
  ExclamationCircleOutline,
  SettingOutline,
  UserAddOutline,
  DollarOutline,
  LockOutline,
  StopOutline,
  StopTwoTone,
  MailTwoTone,
  EditTwoTone,
  EditOutline,
  PlayCircleTwoTone,
  UsergroupAddOutline,
  HomeOutline,
  ShopOutline,
  BankOutline,
  AudioOutline,
  HeartOutline,
  ThunderboltOutline,
  SmileOutline,
  ScissorOutline,
  FileSearchOutline,
  FileProtectOutline,
  ApiOutline,
  BulbOutline,
  MedicineBoxOutline,
  ExperimentOutline,
  RocketOutline,
  DropboxOutline,
  BranchesOutline,
  SkinOutline,
  SafetyCertificateOutline,
  TeamOutline,
  ClusterOutline,
  RestOutline,
  MobileOutline,
  CheckCircleOutline,
  PlayCircleOutline,
  PauseCircleOutline,
  CopyOutline,
  DeleteOutline,
  MinusCircleOutline,
  MinusSquareOutline,
  HighlightOutline,
  PicLeftOutline,
  PicRightOutline,
  LeftOutline,
  RightOutline,
  LayoutOutline,
  // Records filter icons
  FilterOutline,
  AppstoreOutline,
  SolutionOutline,
  ToolOutline,
  CalendarOutline,
  CloseOutline,
  CloseCircleOutline,
  UnorderedListOutline,
  LinkOutline,
  SortAscendingOutline,
  SortDescendingOutline,
  ShareAltOutline,
  FullscreenOutline,
  BellOutline,
  ReloadOutline,
  ReadOutline,
  SoundOutline,
  RedoOutline,
  UndoOutline,
  MutedOutline,
  MinusOutline,
  SendOutline,
  SignatureOutline,
  UploadOutline,
  CloudUploadOutline,
  CloudDownloadOutline,
  PauseOutline,
  CaretRightOutline,
  EllipsisOutline,
  LikeOutline,
  LikeFill,
  DislikeOutline,
  DislikeFill,
} from '@ant-design/icons-angular/icons';
import { IconDefinition } from '@ant-design/icons-angular';

// Custom icon: Ant Design has no bookmark
const BookmarkFill: IconDefinition = {
  name: 'bookmark',
  theme: 'fill',
  icon: '<svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"><path d="M7 4h10v16l-5-3.5L7 20z"></path></svg>',
};

const stroked = (paths: string, strokeWidth = 1.8) =>
  `<svg viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-width="${strokeWidth}" stroke-linecap="round" stroke-linejoin="round">${paths}</g></svg>`;

const RecordStopFill: IconDefinition = {
  name: 'record-stop',
  theme: 'fill',
  icon: '<svg viewBox="0 0 24 24"><rect x="7" y="7" width="10" height="10" rx="2"></rect></svg>',
};

const CloudCheckOutline: IconDefinition = {
  name: 'cloud-check',
  theme: 'outline',
  icon: stroked(
    '<path d="M7 18a4.5 4.5 0 1 1 .6-8.96A6 6 0 0 1 18.6 10 4 4 0 0 1 17 18z"></path><path d="M9.5 13.5l2 2 3.5-3.5"></path>',
  ),
};

const CloudOffOutline: IconDefinition = {
  name: 'cloud-off',
  theme: 'outline',
  icon: stroked(
    '<path d="M7 18a4.5 4.5 0 1 1 .6-8.96A6 6 0 0 1 18.6 10 4 4 0 0 1 17 18z"></path><path d="M4 4l16 16"></path>',
  ),
};

const skipLabel = (x: number) =>
  `<text x="${x}" y="15.2" font-size="7.5" font-weight="600" text-anchor="middle" fill="currentColor" stroke="none">10</text>`;

const Replay10Outline: IconDefinition = {
  name: 'replay-10',
  theme: 'outline',
  icon: stroked(
    `<path d="M4 12a8 8 0 1 0 2.3-5.6"></path><path d="M4 3.5v4h4"></path>${skipLabel(12.5)}`,
    1.6,
  ),
};

const Forward10Outline: IconDefinition = {
  name: 'forward-10',
  theme: 'outline',
  icon: stroked(
    `<path d="M20 12a8 8 0 1 1-2.3-5.6"></path><path d="M20 3.5v4h-4"></path>${skipLabel(11.5)}`,
    1.6,
  ),
};

export const icons = [
  MenuFoldOutline,
  MenuUnfoldOutline,
  DashboardOutline,
  FormOutline,
  HistoryOutline,
  LogoutOutline,
  FileTwoTone,
  DownloadOutline,
  ShareAltOutline,
  InboxOutline,
  FileTextOutline,
  EyeInvisibleOutline,
  EyeOutline,
  PlusOutline,
  MenuFoldOutline,
  MenuUnfoldOutline,
  FilePdfFill,
  FilePdfOutline,
  FileAddOutline,
  UserOutline,
  SettingFill,
  PlusSquareFill,
  FileImageOutline,
  AudioOutline,
  FileUnknownOutline,
  ArrowUpOutline,
  ArrowDownOutline,
  MessageOutline,
  ArrowLeftOutline,
  MailOutline,
  WarningOutline,
  UpOutline,
  DownOutline,
  ZoomInOutline,
  ZoomOutOutline,
  ArrowRightOutline,
  SettingOutline,
  UserAddOutline,
  DollarOutline,
  LockOutline,
  StopTwoTone,
  MailTwoTone,
  EditTwoTone,
  PlayCircleTwoTone,
  UsergroupAddOutline,
  StopOutline,
  HomeOutline,
  ShopOutline,
  BankOutline,
  MobileOutline,
  LoadingOutline,
  CheckCircleOutline,
  PlayCircleOutline,
  PauseCircleOutline,
  // Icons used in payment flows
  CreditCardOutline,
  GiftOutline,
  CheckOutline,
  InfoCircleOutline,
  ExclamationCircleOutline,
  // Specialty icons
  HeartOutline,
  ThunderboltOutline,
  SmileOutline,
  ScissorOutline,
  FileSearchOutline,
  FileProtectOutline,
  ApiOutline,
  BulbOutline,
  MedicineBoxOutline,
  ExperimentOutline,
  RocketOutline,
  DropboxOutline,
  BranchesOutline,
  SkinOutline,
  SafetyCertificateOutline,
  TeamOutline,
  ClusterOutline,
  RestOutline,
  // PI report editor icons
  MenuOutline,
  EditOutline,
  CopyOutline,
  PlusCircleOutline,
  PlusSquareOutline,
  DeleteOutline,
  MinusCircleOutline,
  MinusSquareOutline,
  HighlightOutline,
  // Layout icons
  PicLeftOutline,
  PicRightOutline,
  LeftOutline,
  RightOutline,
  LayoutOutline,
  // Records component filter icons
  FilterOutline,
  AppstoreOutline,
  SolutionOutline,
  ToolOutline,
  CalendarOutline,
  CloseOutline,
  CloseCircleOutline,
  UnorderedListOutline,
  LinkOutline,
  SortAscendingOutline,
  SortDescendingOutline,
  ArrowDownOutline,
  FullscreenOutline,
  BellOutline,
  ReloadOutline,
  ReadOutline,
  SoundOutline,
  RedoOutline,
  UndoOutline,
  MutedOutline,
  MinusOutline,
  // EHR push icon
  SendOutline,
  SignatureOutline,
  UploadOutline,
  BookmarkFill,
  CloudUploadOutline,
  CloudDownloadOutline,
  PauseOutline,
  CaretRightOutline,
  RecordStopFill,
  CloudCheckOutline,
  CloudOffOutline,
  Replay10Outline,
  Forward10Outline,
  SignatureOutline,
  UploadOutline,
  EllipsisOutline,
  // Report feedback thumbs (outline = unrated, fill = rated)
  LikeOutline,
  LikeFill,
  DislikeOutline,
  DislikeFill,
];
